import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function UpdateConfirmationModal({
  destroyFieldValueCount,
  isOpen,
  onUpdate,
  setClose,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.personnel.information.UpdateConfirmationModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const closeModalBox = () => {
    setClose();
  };

  const handleDeleteClick = () => {
    closeModalBox();
    onUpdate();
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, [isOpen]);

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={closeModalBox}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={handleDeleteClick}>
            {i18nTShared('deleteRecordsWithCount', {
              count: destroyFieldValueCount,
            })}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={closeModalBox}
    >
      <div className='modalbox-body'>
        <div className='tw-mb-4 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </div>
        <div>{i18nT('description')}</div>
      </div>
    </ModalBox>
  );
}

UpdateConfirmationModal.propTypes = {
  destroyFieldValueCount: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
  setClose: PropTypes.func.isRequired,
};
